module.exports = __webpack_public_path__ + "img/2-small.99ef9208.png";